import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { Nav } from './components/Nav';
import { NavButton } from './components/NavButton';
import { CHANGE_GLOSSARY_MODAL_VISIBILITY } from '../../../../store/js/modules/statspro/glossary/actions';

import { Search } from '../Search';

export const Header = ({ compseason, showCompare }) => {
    const dispatch = useDispatch();
    const showGlossaryModal = () => {
        return dispatch(
            CHANGE_GLOSSARY_MODAL_VISIBILITY.request({ isVisible: true })
        );
    };

    return (
        <div className="stats-header">
            <div className="stats-header__wrapper wrapper mb-0">
                <div className="stats-header__search-wrapper">
                    <Search compseason={compseason} />
                </div>
                <div className="stats-header__nav-wrapper">
                    <Nav showCompare={showCompare} />
                </div>
                <div className="stats-header__glossary-wrapper">
                    <NavButton
                        text="Glossary"
                        icon="info-circle"
                        onClick={showGlossaryModal}
                    />
                </div>
            </div>
        </div>
    );
};

Header.propTypes = {
    compseason: PropTypes.string,
    showCompare: PropTypes.bool.isRequired
};
